import { ToDoDocuments } from "components/general/ToDo";
import BreadCrumV2 from "components/individual/breadCrums/BreadCrumV2";
import useQueryParams from "customHooks/useQueryParams";
import React from "react";

export const ToDoInvoiceEmitted = () => {
  /**
   * @type {import('types/typedef/customHooks/useQueryParams').ToDoQueryParams}
   */
  const { cliente, documento } = useQueryParams();

  return (
    <>
      <BreadCrumV2
        path={[
          {
            text: "Inicio",
            route: "/inicio",
          },
          {
            text: "Administracion",
            route: "/administracion",
          },
          {
            text: "Facturas emitidas",
            route: "/administracion/facturas-emitidas",
          },
          {
            text: "To Do",
            route: "",
          },
        ]}
      />
      <ToDoDocuments cliente={cliente} documento={documento} />
    </>
  );
};
